import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { MOVE_STATUS_ALLOW, MOVE_STATUS_CREATE_NOT_COMPLETE, MOVE_STATUS_ERROR, MOVE_STATUS_MULTI, MOVE_STATUS_PERMIT, MOVE_STATUS_SIZE_LIMIT_COLLABORATOR, MOVE_STATUS_SIZE_LIMIT_OWNER, MOVE_STATUS_UNKNOWN, RETCODE_MOVE_STATUS_SIZE_LIMIT_COLLABORATOR, RETCODE_MOVE_STATUS_SIZE_LIMIT_OWNER } from "../constants/MoveStatus";
import { ICollaborationFlag } from '@tencent/ark-service-interface';
import { ajaxGet } from '@tencent/docs-scenario-components-utils/dist/ajax';
import { getXsrf } from '@tencent/docs-scenario-components-utils/dist/helper';
import { getUtype } from '@tencent/docs-multi-tools';
import { tdwReport } from '@tencent/docs-scenario-components-utils/dist/report';
import { tencentDocOpenUrlForAll, getMultUrl } from '@tencent/tencent_doc_open_url';
import { OPERATION_TYPE, showSizeLimitDialog } from '@tencent/docs-scenario-components-pc-folder-selector';
import { $t } from '@tencent/docs-scenario-components-language-pack';
import { setGlobalAid, POSITIONS } from '@tencent/docs-scenario-components-aid-globle';
import ua from '@tencent/docs-user-agent';
export var BaseMoveFileService = /*#__PURE__*/_createClass(function BaseMoveFileService(folderSelector, _Snackbar, _usePcPlatform) {
  var _this = this;
  _classCallCheck(this, BaseMoveFileService);
  _defineProperty(this, "move", {
    isDisabled: false,
    isDoGetting: false,
    isShowMove: false,
    status: MOVE_STATUS_UNKNOWN,
    // 0表示可以移动，1表示拉取出错，2表示因为有多个不能移动，3表示因为权限不能移动
    folderId: '',
    parentFolderId: '',
    folderPolicy: 0,
    collaborationFlag: ICollaborationFlag.NOT_IN_COLLABORATION,
    isMyFolder: false,
    addSuccessCb: undefined
  });
  _defineProperty(this, "init", function (options) {
    var move = _this.move,
      notify = _this.notify,
      getMoveInfo = _this.getMoveInfo,
      isShowMove = _this.isShowMove,
      setSnackbarConfigs = _this.setSnackbarConfigs;
    move.addSuccessCb = options.addSuccessCb;
    move.hideCb = options.hideCb;
    setSnackbarConfigs();
    if (window.clientVars.docStatus === 12) {
      var _window$SLR;
      move.isDisabled = true;
      move.isShowMove = !!window.clientVars.isCreator;
      notify(options.initCb);
      (_window$SLR = window.SLR) === null || _window$SLR === void 0 || _window$SLR.listen('DOC_HUMTRANS_DONE', function () {
        move.isDisabled = false;
        notify(options.initCb);
      });
    } else {
      getMoveInfo(function () {
        move.isShowMove = isShowMove();
        notify(options.initCb);
      });
    }
  });
  _defineProperty(this, "handleClick", function () {
    var getMoveInfo = _this.getMoveInfo,
      isShowMove = _this.isShowMove,
      move = _this.move,
      buildDocInfo = _this.buildDocInfo,
      usePcPlatform = _this.usePcPlatform,
      Snackbar = _this.Snackbar;
    tdwReport({
      opername: 'doc_manage',
      module: 'detail',
      action: move.isShowMove ? 'move_to_clk' : 'add_to_clk',
      ver12: move.isDisabled ? '1' : '2'
    });
    getMoveInfo(function () {
      move.isShowMove = isShowMove();
      if (move.status === MOVE_STATUS_ERROR) {
        Snackbar.show({
          type: 'error',
          duration: 5000,
          message: $t('获取文件夹信息出错，请刷新重试。'),
          action: $t('刷新'),
          onClickAction: function onClickAction() {
            // 这里要带一下u
            var url = getMultUrl(location.href);
            window.location.replace(url);
          },
          autoClose: true,
          style: {
            zIndex: 10003
          }
        });
      } else if (move.status === MOVE_STATUS_MULTI) {
        Snackbar.show({
          type: 'info',
          duration: 5000,
          message: usePcPlatform ? $t('本文已有多个快捷方式，请前往首页整理。') : $t('本文有多个快捷方式'),
          action: $t('去整理'),
          onClickAction: function onClickAction() {
            tdwReport({
              opername: 'doc_manage',
              module: 'detail',
              action: 'move_to_toast_golist_clk'
            });
            if (usePcPlatform) {
              tencentDocOpenUrlForAll({
                url: "https://".concat(location.hostname, "/desktop/search?keyword=").concat(encodeURIComponent(window.clientVars.padTitle), "&search_hl_padid=").concat(window.clientVars.localPadId)
              });
            } else {
              tencentDocOpenUrlForAll({
                url: "https://".concat(location.hostname, "/desktop/m/search.html?keyword=").concat(encodeURIComponent(window.clientVars.padTitle), "&search_hl_padid=").concat(window.clientVars.localPadId)
              });
            }
          },
          autoClose: true,
          style: {
            zIndex: 10003
          }
        });
        tdwReport({
          opername: 'doc_manage',
          module: 'detail',
          action: 'move_to_toast_golist_expo'
        });
      } else if (move.status === MOVE_STATUS_CREATE_NOT_COMPLETE) {
        Snackbar.show({
          type: 'info',
          duration: 5000,
          message: $t('共享文档信息同步中，请稍后重试。'),
          autoClose: true
        });
      } else if (move.status === MOVE_STATUS_SIZE_LIMIT_OWNER) {
        showSizeLimitDialog(true);
      } else if (move.status === MOVE_STATUS_SIZE_LIMIT_COLLABORATOR) {
        showSizeLimitDialog(false);
      } else {
        setGlobalAid({
          position: POSITIONS.DETAIL,
          feature: 'space',
          apprec1: 'move',
          apprec2: window.clientVars.padType
        });
        _this.folderSelector.show({
          docInfo: buildDocInfo(),
          operationType: isShowMove() ? OPERATION_TYPE.MOVE : OPERATION_TYPE.ADD_TO,
          addSuccessCb: function addSuccessCb() {
            var _move$addSuccessCb;
            move.isShowMove = true;
            (_move$addSuccessCb = move.addSuccessCb) === null || _move$addSuccessCb === void 0 || _move$addSuccessCb.call(move);
          },
          hideCb: function hideCb() {
            var _move$hideCb;
            (_move$hideCb = move.hideCb) === null || _move$hideCb === void 0 || _move$hideCb.call(move);
          }
        });
      }
    });
  });
  _defineProperty(this, "hide", function () {
    _this.folderSelector.hide();
  });
  /**
  * 初始化 Native 端 SnackBar配置
  */
  _defineProperty(this, "setSnackbarConfigs", function () {
    var Snackbar = _this.Snackbar;
    // app则预留app的titlebar高度
    if (ua.isTencentDocsApp) {
      Snackbar.show.configDefaults({
        style: {
          marginTop: 44,
          top: 10
        }
      });
    }

    // iframe内，设置为0，主要考虑drive套壳的场景
    if (window.top !== window.self) {
      Snackbar.show.configDefaults({
        style: {
          marginTop: 0,
          top: 10
        }
      });
    }
  });
  _defineProperty(this, "getMoveInfo", function (cb) {
    var move = _this.move;
    var weWork = 'ww';
    if (move.isDoGetting || getUtype() === weWork) {
      return;
    }
    move.isDoGetting = true;
    var paramString = {
      domainId: window.clientVars.domainId,
      padId: window.clientVars.localPadId,
      xsrf: getXsrf()
    };
    var url = "//".concat(location.hostname, "/cgi-go/can/move");
    return ajaxGet(url, paramString).then(function (data) {
      move.isDoGetting = false;
      try {
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        if (data.retcode === 0) {
          move.status = MOVE_STATUS_ALLOW;
          move.folderId = data.data.folder_info.folder_id;
          move.parentFolderId = data.data.folder_info.parent_folder_id;
          move.folderPolicy = data.data.folder_info.folder_policy;
          move.collaborationFlag = data.data.folder_info.collaboration_flag;
          move.isMyFolder = !!data.data.folder_info.is_my_folder;
        } else if (data.retcode === 1000) {
          move.status = MOVE_STATUS_MULTI;
        } else if (data.retcode === 1004) {
          move.status = MOVE_STATUS_PERMIT;
          move.folderId = '';
          move.parentFolderId = '';
          move.folderPolicy = 0;
          move.collaborationFlag = ICollaborationFlag.NOT_IN_COLLABORATION;
          move.isMyFolder = false;
        } else if (data.retcode === 1005) {
          move.status = MOVE_STATUS_CREATE_NOT_COMPLETE;
        } else if (data.retcode === RETCODE_MOVE_STATUS_SIZE_LIMIT_OWNER) {
          move.status = MOVE_STATUS_SIZE_LIMIT_OWNER;
        } else if (data.retcode === RETCODE_MOVE_STATUS_SIZE_LIMIT_COLLABORATOR) {
          move.status = MOVE_STATUS_SIZE_LIMIT_COLLABORATOR;
        } else {
          move.status = MOVE_STATUS_ERROR;
        }
      } catch (e) {
        move.status = MOVE_STATUS_ERROR;
      }
      cb === null || cb === void 0 || cb();
    }).catch(function () {
      move.isDoGetting = false;
      move.status = MOVE_STATUS_ERROR;
      cb === null || cb === void 0 || cb();
    });
  });
  _defineProperty(this, "isShowMove", function () {
    var move = _this.move;
    return move.status === MOVE_STATUS_ALLOW && (window.clientVars.isOwner || move.isMyFolder) || move.status === MOVE_STATUS_MULTI;
  });
  _defineProperty(this, "notify", function (cb) {
    var move = _this.move;
    cb === null || cb === void 0 || cb({
      isDisabled: move.isDisabled,
      isShowMove: move.isShowMove
    });
  });
  _defineProperty(this, "buildDocInfo", function () {
    var move = _this.move,
      getDocType = _this.getDocType;
    return {
      folder_id: '',
      list_info_type: 1,
      parent_folder_id: move.folderId,
      is_owner: window.clientVars.isCreator,
      doc_type: getDocType(),
      parent_folder_policy: move.folderPolicy,
      is_my_folder: move.isMyFolder,
      domain_id: window.clientVars.domainId,
      pad_id: window.clientVars.localPadId,
      collaboration_flag: move.collaborationFlag
    };
  });
  _defineProperty(this, "getDocType", function () {
    if (window.clientVars.padType === 'sheet') {
      return 1;
    }
    if (window.clientVars.padType === 'form') {
      return 2;
    }
    return 0;
  });
  this.folderSelector = folderSelector;
  this.Snackbar = _Snackbar;
  this.usePcPlatform = _usePcPlatform;
});